export const POST_COURSE_FOLLOWUPS = "/api/folders/:param/post-courses"
export const POST_COURSE_FOLLOWUP = "/api/post-courses/:postCourseFollowUpParam"
export const CLOSE_POST_COURSE_FOLLOWUP = "/api/post-courses/:postCourseFollowUpParam/close"
export const EXPORT_POST_COURSE_FOLLOWUP = "/api/post-courses/export"
